// extracted by mini-css-extract-plugin
export default {"bgimg":"impact_bgimg__NwJOI","ctacontainer":"impact_ctacontainer__f3Ktv","donationtrackerpadding":"impact_donationtrackerpadding__+8eeU","btn-white":"impact_btn-white__UXBtq"};